<template>
    <div id="mainDIV">
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>




        <div class="container-fluid mt--7" :dir="language">
            <div class="row">
                <div class="col-md-7" v-if="isChatOpen">

                    <projects-table title="Progress" :tableData="overview" @viewLogs="viewPostponingLogs($event)" ></projects-table>
                </div>
                <div class="col" v-else>

                    <projects-table title="Progress" :tableData="overview" @viewLogs="viewPostponingLogs($event)" ></projects-table>
                </div>
                <div class="col-md-5" v-if="isChatOpen">
                  <card header-classes="bg-white" style="background-color: white;background: #fff;position: -webkit-sticky;
      position: sticky;  top: 0;">
                <template slot="header">
                  <div class="row" style="margin-top:-15px;">
                  <div class="col-md-7" style="margin-bottom:-20px;margin-top:0px;">
                  <h2 v-if="language == 'ltr'" >{{texts.chats}}</h2>
                  <h2 v-else style="text-align:right" >{{texts.chats}}</h2>
                  </div>
                  <!--suffix="<span pill class='badge' style='background:red;color:#fff;margin-top:-40px;margin-right:-10px;'>4</span>"-->
                  <div style="margin-bottom:-18px;margin-top:10px;">
                    <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged" v-if="language =='ltr'">
                        <tab id="public" name="Public Chat">

                        </tab>
                        <tab id="private" name="Private Chats" >

                        </tab>
                        <tab id="contacts" name="Contacts">

                        </tab>
                    </tabs>
                    <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged" v-else dir="rtl">
                        <tab id="public" :name="texts.publicchat">

                        </tab>
                        <tab id="private" :name="texts.privatechat" >

                        </tab>
                        <tab id="contacts" :name="texts.contacts">

                        </tab>
                    </tabs>
                </div>
                  <!-- <div class="col-md-5" style="text-align : right;margin-bottom:-20px;margin-top:-20x;" v-if="showEnquiry">
                  <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && enquirySelected" v-on:click="viewPrivateInquiries">{{texts.privatechat}}  <badge type="white"></badge></base-button>
                  <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && !enquirySelected" v-on:click="viewPrivateInquiries">{{texts.publicchat}}  <badge type="white"></badge></base-button>
                  </div> -->
                  </div>
                   <!-- <span style="font-size: 18px; color: black;width:85%;" id="exampleModalLabel">{{texts.inquiry}}</span> -->
                </template>
                <!-- <div> -->

                <div style="height:90%;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="!showEnquiry && !isContacts">
                  <card v-for="chat in private_inquiries" header-classes="bg-white" style="background-color: white;background: #fff;margin-bottom:15px;" >
                    <div class="row" style="margin-top:-20px;">

                      <!-- <div  class="col-md-1" style="margin-top:-12px;">
                      <badge  type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">!</badge>
                      </div> -->

                      <div class="col-md-8" style="margin-top:3px;">
                        <h4  >{{chat.title}}</h4>
                      </div>

                      <div class="col-md-4" style="margin-top:-10px;">
                        <button type="button" style="float: right;margin-top: 10px;" class="btn btn-success btn-sm" v-on:click="inquiryClicked(chat)">{{texts.view}}   <badge type="white"></badge></button>
                      </div>

                        <!-- </div> -->
                      <!-- <br> -->
                      <!-- <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
                      <br>
                      <br>
                      <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

                      <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span> -->
                    </div>
                    <div class="row" style="margin-top:-15px;">
                      <div class="col-md-12">
                        <span style="font-size:14px;">
                          {{chat.last_message.message}}
                        </span>
                      </div>
                    </div>

                    <div class="row" style="margin-bottom:-15px;">
                      <div class="col-md-12">
                        <span style="font-size:12px;">
                          {{chat.last_message.datetime}}
                        </span>
                      </div>
                    </div>
                  </card>
                  <!-- <div v-for="(r, pos) in inquiries">
                 <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " ><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
                 <br>
                 </div> -->
                </div>

                <div style="/*overflow-y: scroll; height:200px;*/height:200px;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="inquiries.length > 0 && showEnquiry">

                  <div v-for="(r, pos) in inquiries">
                 <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " ><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
                 <br>
                 </div>
                </div>
                <div v-if="showEnquiry">
                  <br>
                <textarea v-if="language == 'ltr'" class="form-control"  placeholder="Write a message.."
                                 type="text"
                                 v-model="chat_message" rows="3"
                                 >
                     </textarea>
                     <textarea v-else dir="rtl" class="form-control"  placeholder="اكتب رسالة .."
                                      type="text"
                                      v-model="chat_message" rows="3"
                                      >
                          </textarea>

                </div>

                <div class="row" v-if="false" style="margin-bottom:-20px;">
                  <div class="col-md-8">
                    <base-checkbox v-model="is_public" >{{texts.public}}</base-checkbox>
                  </div>
                  <div class="col-md-4" style="margin-bottom:-25px;">
                    <base-checkbox v-model="is_private">{{texts.private}}</base-checkbox>
                  </div>
                  <!-- <div class="col-md-8">
                    <div class="avatar-group">
                      <span href="#" class="avatar avatar-sm rounded-circle myDIV" data-toggle="tooltip" data-original-title="Ryan Tompson"
       v-b-tooltip.hover.left title="Tooltip on left">
                        <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">

                      </span>
                      <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Romina Hadid">
                        <img alt="Image placeholder" src="img/theme/team-2-800x800.jpg">
                      </span>
                      <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Alexander Smith">
                        <img alt="Image placeholder" src="img/theme/team-3-800x800.jpg">
                      </span>
                      <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Jessica Doe">
                        <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg">
                      </span>
                    </div>
                  </div> -->

                </div>

                <template slot="footer" v-if="showEnquiry">
                  <!-- <div class="row"> -->
                    <!-- <div class="col-md-4">
                    <base-button type="secondary" @click="modals.modalinquirybox = false;">{{texts.close}}</base-button>
                    </div> -->
                    <!-- <br> -->
                    <!-- <div class="col-md-1"> -->
                    <base-button type="primary" @click="sendChat()" style="width:100%;height:60px;">{{texts.send}}</base-button>
                    <!-- </div> -->
                    <!-- </div> -->
                    <!-- <base-button v-if="isManager" @click="approveMinutes()" type="primary">{{texts.approveminutes}}</base-button> -->

                </template>

                <div style="overflow-y: scroll; height:300px;" v-if="isContacts">
                  <!-- <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;" v-if="language=='ltr'">{{texts.back}}</base-button>
                  <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;align-items:right;" v-else>{{texts.back}}</base-button> -->
                  <h4 v-if="language == 'ltr'">Client Representatives</h4>
                  <h4 v-else style="text-align:right;">العملاء</h4>
                  <h5 style="color:#808080" v-if="language == 'ltr'">Please tick the Client Representatives you want to include in the message and keep the ones you do not want to include unticked.</h5>
                  <h5 style="color:#808080;text-align:right;" v-else>يرجى وضع علامة على العملاء الذين تريد تضمينهم في الرسالة فقط</h5>
                  <br>
                  <!-- <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos15) in committeemembers" :key="pos15" v-model="committeemembers[pos15].checked">
                         {{fieldName.name}} - {{fieldName.title}}
                     </base-checkbox>

                   <base-checkbox v-else style="text-align:right;" class="mb-3" v-for="(fieldName, pos6) in committeemembers" :key="pos6" v-model="committeemembers[pos6].checked">
                          {{fieldName.name}} - {{fieldName.title}}
                      </base-checkbox> -->

                  <!-- <br> -->
                  <h4 v-if="language == 'ltr'">AIGC</h4>
                  <h4 v-else style="text-align:right;">AIGC</h4>
                  <!-- <h4 v-else>Team Members</h4> -->
                  <!-- <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos7) in teammembers" :key="pos7" v-model="teammembers[pos7].checked">
                         {{fieldName.name}} - {{fieldName.title}}
                     </base-checkbox>

                   <base-checkbox v-else style="text-align:right;" class="mb-3" v-for="(fieldName, pos8) in teammembers" :key="pos8" v-model="teammembers[pos8].checked">
                          {{fieldName.name}} - {{fieldName.title}}
                      </base-checkbox> -->


              </div>
              <template slot="footer" style="justify-content:centered;" v-if="isContacts">
                  <base-button type="primary" @click="initiatePrivateChat()" style="width:100%;height:60px;">{{texts.send}}</base-button>
              </template>

                <!-- </div> -->
                </card>
                  </div>
            </div>
        </div>

        <div v-if="language == 'ltr'">
          <base-button class="btn-primary"  icon="ni ni-chat-round" style='position: fixed;bottom: 27px;right: 15px;height:44px;border-radius:50px;font-size:15px;background-color: rgb(79, 47, 129);' v-on:click="openChatModal">&nbsp;{{texts.chats}}</base-button>
        </div>
        <div v-else style="text-align : left;">
          <base-button class="btn-primary"  icon="ni ni-chat-round" style='position: fixed;bottom: 27px;right: 15px;height:44px;border-radius:50px;font-size:15px;background-color: rgb(79, 47, 129);' v-on:click="openChatModal">&nbsp;{{texts.chats}}</base-button>
        </div>
         <div>
           <!-- SHOW FILE WASS SET TO FALSE -->
          <!-- <beautiful-chat style="z-index: 1;position: relative"  v-if="isChatHidden" id="chat"
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="false"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" /> -->
        </div>


        <modal :show.sync="modals.modalonboarding"
               modal-classes="modal-dialog-centered modal-lg"  :dir="language">
               <div class="row" style="text-align: right;margin-top: -10px; margin-bottom: -10px;">
                <div class="col-md-12">
               <base-button class="btn-info btn-sm" style="margin-top:-10px;margin-bottom:5px;" v-on:click="closeOnboarding">X</base-button>
               </div>
               </div>
               <div class="row" style="margin-top: -20px;">
                 
               <div class="col-md-12" >
               <h3 style="margin-top:-5px;margin-bottom:0px;text-align:center;" >{{texts.onboarding}}</h3>

               </div>
               
               </div>
          <slider v-if="modals.modalonboarding" animation="normal" style="height:365px;" interval="10000" speed="500" control-btn="true" stopOnHover="true" autoplay="false" @change="sliderChanged($event)" v-model="currentIndex">
                <slider-item
                  v-for="(i, index) in list"
                  :key="index"
                  :style="i">
                <div style="text-align:center;">
                  <img src="../../screenshots/Picture1.png" style="height:100%;width:100%" v-if="currentIndex == 0"></img>
                  <img src="../../screenshots/Picture2.png" style="height:100%;width:100%" v-if="currentIndex == 1"></img>
                  <img src="../../screenshots/Picture3.png" style="height:100%;width:100%" v-if="currentIndex == 2"></img>
                  <img src="../../screenshots/Picture4.png" style="height:100%;width:100%" v-if="currentIndex == 3"></img>
                  <img src="../../screenshots/Picture5.png" style="height:100%;width:100%" v-if="currentIndex == 4"></img>
                  <img src="../../screenshots/Picture6.png" style="height:80%;width:80%"   v-if="currentIndex == 5"></img>
                  <img src="../../screenshots/Picture7.png" style="height:100%;width:100%" v-if="currentIndex == 6"></img>
                </div>

                  <!-- <p style="line-height: 280px; font-size: 5rem; text-align: center;">Page{{ index + 1 }}</p> -->
                </slider-item>
          </slider>
          <div class="row" v-if="language=='ltr'" style="margin-bottom:-30px;">
          <div class="col-md-6" style="text-align : left;">

            <base-button class="btn-primary btn-sm" style="margin-top:5px;margin-bottom:-5px;" v-on:click="backOnBoarding">{{texts.back}}</base-button>
          </div>
          <div class="col-md-6" style="text-align : right;">
            <base-button class="btn-primary btn-sm" style="margin-top:5px;margin-bottom:-5px;text-align:right;" v-on:click="nextOnBoarding">{{texts.next}}</base-button>
          </div>
          </div>
          <div class="row" v-else style="margin-bottom:-30px;">
          <div class="col-md-6" style="text-align : left;">
            <base-button class="btn-primary btn-sm" style="margin-top:5px;margin-bottom:-5px;" v-on:click="nextOnBoarding">{{texts.next}}</base-button>
          </div>
          <div class="col-md-6" style="text-align : right;">
            <base-button class="btn-primary btn-sm" style="margin-top:5px;margin-bottom:-5px;text-align:right;" v-on:click="backOnBoarding">{{texts.back}}</base-button>
          </div>
          </div>
          <div style="text-align:center;height:150px;" v-if="currentIndex == 0" >
            <br>
            <h4>Main page: الصفحة الرئيسية</h4>
            <span>This is the main “overview” screen.  It highlights the project scope and schedule.</span><br>
            <span>تظهر الصفحة الرئيسية "نظرة عامة" حول حالة المشروع ومراحله والجدول الزمني له</span><br>
            <span>On the right side of every phase press on “view” to find the deliverables relating to each phase.</span><br>
            <span>في الجهة اليسرى من الشاشة(في حال تم إختيار اللغه الإنجليزيه)، يمكن عبر اختيار "عرض" الانتقال إلى شاشة المخرجات (التقارير) الخاصة بكل مرحلة</span>
            </div>

          <div style="text-align : center;height:150px;" v-if="currentIndex == 1" >
            <br>
          <span>The Deliverables screen shows the list of reports and the charts that summarize the results of each report.</span><br>
<span>تُظهر شاشة المخرجات التقارير والرسوم البيانية  التي تلخص نتائج كل تقرير</span><br>
<span>Press on “View Report to display the complete report</span><br>
<span>عند اختيار "عرض التقرير" يمكنك استعراض التقرير كاملا</span>

          </div>
          <div style="text-align : center;height:150px;" v-if="currentIndex == 2" >
            <br>
            <span>This screen allows you to scroll through the report and download it as a PDF. You can also send inquiries to AIGC Team while reviewing the report through the inquiries section of the screen.</span><br>
            <span>PDF
تسمح  هذه الشاشة باستعراض التقرير وتصفّحه، كما وتسمح لك بتنزيل نسخة من التقرير على جهازك على شكل </span><br>
<span>يمكنك أيضاً عبر شاشة الاستفسارات طرح أي أسئلة لديك للفريق الاستشاري</span><br>
          </div>
          <div style="text-align : center;height:150px;font-size:12px;" v-if="currentIndex == 3" >
            <br>
          <h4>Settings (configuration menu): الإعدادات </h4>


<!-- <span>The Menu on the top right side of the screen ascending after clicking on your name, provides the following:</span> -->
<span>Click on your name (appearing on the top right corner of the screen) to obtain a menu that provides you with the ability to: Change the language, Access assignments, Access the Settings page to: edit your personal Information, change the password, and set your email notification preferences, Logout the system.
</span>
</span>
<br>
<span>عند النقر على اسمك (والذي يظهر في الجزء العلوي من الشاشة)، ستظهر لك قائمة بالإعدادات تمكّنك من الآتي</span>
<span>تغيير اللغة، الدخول على المشاريع الخاصه بك، الدخول على شاشة الإعدادات والتي تمكنك من: تغيير معلوماتك الشخصية وكلمة السر الخاصة بك وتحديد إختياراتك للرسائل التنبيهية، خروج من النظام</span>


          </div>

          <div style="text-align:center;height:150px;" v-if="currentIndex == 4" >
            <br>
          <h4>Left Pane: الجزء الأيسر من الشاشة</h4>
<span>On the left side of the screen, you can find the menu that will direct you to the following screens:</span><br>
<span>Main Overview, Calendar, List of meetings</span><br>
<span>سيظهر لك على جانب الشاشة،  القائمة التالية:</span>
<span>نظرة عامة، التقويم، قائمة الاجتماعات</span>
            </div>

            <div style="text-align : center;height:150px;" v-if="currentIndex == 5" >
              <br>
              <h4>Calendar: التقويم</h4>
<span>This Calendar shows to you the "Meetings" dates and information on the meetings you were invited to.</span><br>
<span>تُظهر شاشة التقويم لك المعلومات والتواريخ المتعلقة بالاجتماعات التي تم دعوتك إليها</span><br>
<span>Upon clicking on any of the meetings in the Calendar (colored in purple), the details of the meeting will appear in addition to the minutes of meeting.</span><br>
<span>بالنقر على قائمة الاجتماعات، ستظهر لك قائمة مفصلة بكافة الاجتماعات التي تم دعوتك لها، و يمكنك استعراض تفاصيل كل اجتماع من تلك القائمة</span>


              </div>

              <div style="text-align : center;height:150px;" v-if="currentIndex == 6" >
                <br>
                <span>You can view the minutes of meeting through the system or download them on your device.</span><br>
                <span>بإمكانك استعراض محضر الاجتماع عبر النظام أو تنزيله على جهازك</span>

              </div>

              <div style="text-align : center;height:150px;" v-if="currentIndex == 7">
                <br>
                <h4>List of Meetings: الاجتماعات</h4>
<span>Clicking on the “meetings” will show you a detailed list of all the meetings that you were invited to, where you can also view the details of each meeting from the list.</span><br>
<span>بالنقر على قائمة الاجتماعات، ستظهر لك قائمة مفصلة بكافة الاجتماعات التي تم دعوتك لها، و يمكن لك استعراض تفاصيل كل اجتماع من تلك القائمة</span>

              </div>

        </modal>


        <modal id="mainChatModal" :show.sync="modals.chatmodal" dir="ltr" style="width:400px;margin-left:70%;background:#f0f0;" v-if="language=='ltr'">
          <!-- <div class="col-md-4" style=""> -->
          <template slot="header">
            <div class="row" style="margin-top:-15px;">
            <div class="col-md-7" style="margin-bottom:-20px;margin-top:0px;">
            <h2 v-if="language == 'ltr'" >{{texts.chats}}</h2>
            <h2 v-else style="text-align:right" >{{texts.chats}}</h2>
            </div>
            <!--suffix="<span pill class='badge' style='background:red;color:#fff;margin-top:-40px;margin-right:-10px;'>4</span>"-->
            <!-- <div style="margin-bottom:-18px;margin-top:10px;">
              <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged">
                  <tab id="public" name="Public Chat">

                  </tab>
                  <tab id="private" name="Private Chats" >

                  </tab>
                  <tab id="contacts" name="Contacts">

                  </tab>
              </tabs>
          </div> -->
            <!-- <div class="col-md-5" style="text-align : right;margin-bottom:-20px;margin-top:-20x;" v-if="showEnquiry">
            <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && enquirySelected" v-on:click="viewPrivateInquiries">{{texts.privatechat}}  <badge type="white"></badge></base-button>
            <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && !enquirySelected" v-on:click="viewPrivateInquiries">{{texts.publicchat}}  <badge type="white"></badge></base-button>
            </div> -->
            </div>
             <!-- <span style="font-size: 18px; color: black;width:85%;" id="exampleModalLabel">{{texts.inquiry}}</span> -->
          </template>
            <card id="hello" header-classes="bg-white" style="display:table;/*height:700px;*/background-color: white;background: #fff;position: -webkit-sticky;
position: sticky;  top: 0;width:100%;">

          <!-- <div> -->

          <div style="height:90%;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="!showEnquiry && !isContacts">
            <card v-for="chat in private_inquiries" header-classes="bg-white" style="background-color: white;background: #fff;margin-bottom:15px;" >
              <div class="row" style="margin-top:-20px;">

                <!-- <div  class="col-md-1" style="margin-top:-12px;">
                <badge  type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">!</badge>
                </div> -->

                <div class="col-md-8" style="margin-top:3px;">
                  <h3  >{{chat.title}}</h3>
                </div>

                <div class="col-md-4" style="margin-top:-10px;">
                  <button type="button" style="float: right;margin-top: 10px;" class="btn btn-success btn-sm" v-on:click="inquiryClicked(chat)">{{texts.view}}   <badge type="white"></badge></button>
                </div>

                  <!-- </div> -->
                <!-- <br> -->
                <!-- <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
                <br>
                <br>
                <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

                <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span> -->
              </div>
              <div class="row">
                <div class="col-md-12">
                  <span style="font-size:14px;">
                    {{chat.last_message.message}}
                  </span>
                </div>
              </div>

              <div class="row" style="margin-bottom:-15px;">
                <div class="col-md-12">
                  <span style="font-size:12px;">
                    {{chat.last_message.datetime}}
                  </span>
                </div>
              </div>
            </card>
            <!-- <div v-for="(r, pos) in inquiries">
           <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " ><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
           <br>
           </div> -->
          </div>

          <div style="/*overflow-y: scroll; height:200px;*/height:200px;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="inquiries.length > 0 && showEnquiry">

            <div v-for="(r, pos) in inquiries">
           <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " ><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
           <br>
           </div>
          </div>
          <div v-if="showEnquiry">
            <br>
          <textarea v-if="language == 'ltr'" class="form-control"  placeholder="Write a message.."
                           type="text"
                           v-model="chat_message" rows="3"
                           >
               </textarea>
               <textarea v-else dir="rtl" class="form-control"  placeholder="اكتب رسالة .."
                                type="text"
                                v-model="chat_message" rows="3"
                                >
                    </textarea>

          </div>

          <div class="row" v-if="false" style="margin-bottom:-20px;">
            <div class="col-md-8">
              <base-checkbox v-model="is_public" >{{texts.public}}</base-checkbox>
            </div>
            <div class="col-md-4" style="margin-bottom:-25px;">
              <base-checkbox v-model="is_private">{{texts.private}}</base-checkbox>
            </div>
            <!-- <div class="col-md-8">
              <div class="avatar-group">
                <span href="#" class="avatar avatar-sm rounded-circle myDIV" data-toggle="tooltip" data-original-title="Ryan Tompson"
 v-b-tooltip.hover.left title="Tooltip on left">
                  <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">

                </span>
                <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Romina Hadid">
                  <img alt="Image placeholder" src="img/theme/team-2-800x800.jpg">
                </span>
                <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Alexander Smith">
                  <img alt="Image placeholder" src="img/theme/team-3-800x800.jpg">
                </span>
                <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Jessica Doe">
                  <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg">
                </span>
              </div>
            </div> -->

          </div>

          <template slot="footer" v-if="showEnquiry">
            <!-- <div class="row"> -->
              <!-- <div class="col-md-4">
              <base-button type="secondary" @click="modals.modalinquirybox = false;">{{texts.close}}</base-button>
              </div> -->
              <!-- <br> -->
              <!-- <div class="col-md-1"> -->
              <base-button type="primary" @click="sendChat()" style="width:100%;height:60px;">{{texts.send}}</base-button>
              <!-- </div> -->
              <!-- </div> -->
              <!-- <base-button v-if="isManager" @click="approveMinutes()" type="primary">{{texts.approveminutes}}</base-button> -->

          </template>

          <div style="overflow-y: scroll; height:250px;" v-if="isContacts">
            <!-- <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;" v-if="language=='ltr'">{{texts.back}}</base-button>
            <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;align-items:right;" v-else>{{texts.back}}</base-button> -->
            <h2 v-if="language == 'ltr'">Client Representatives</h2>
            <h2 v-else style="text-align:right;">العملاء</h2>
            <h5 style="color:#808080" v-if="language == 'ltr'">Please tick the Client Representatives you want to include in the message and keep the ones you do not want to include unticked.</h5>
            <h5 style="color:#808080;text-align:right;" v-else>يرجى وضع علامة على العملاء الذين تريد تضمينهم في الرسالة فقط</h5>
            <br>
            <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos10) in committeemembers" :key="pos10" v-model="committeemembers[pos10].checked">
                   {{fieldName.name}} - {{fieldName.title}}
               </base-checkbox>

             <base-checkbox v-else style="text-align:right;" class="mb-3" v-for="(fieldName, pos11) in committeemembers" :key="pos11" v-model="committeemembers[pos11].checked">
                    {{fieldName.name}} - {{fieldName.title}}
                </base-checkbox>

        </div>
        <template slot="footer" style="justify-content:centered;" v-if="isContacts">
            <base-button type="primary" @click="sendPrivateChatMessage()" style="width:100%;height:60px;">{{texts.send}}</base-button>
        </template>

          <!-- </div> -->
          </card>
          <!-- </div> -->
        </modal>
        <modal id="mainChatModal" :show.sync="modals.chatmodal" dir="ltr" style="width:400px;margin-right:70%;background:#f0f0;" v-else>
          <!-- <div class="col-md-4" style=""> -->
          <template slot="header">
            <div class="row" style="margin-top:-15px;">
            <div class="col-md-12" style="margin-bottom:-20px;margin-top:0px;">
            <h2 v-if="language == 'ltr'" >{{texts.chats}}</h2>
            <h2 v-else style="text-align:right" >{{texts.chats}}</h2>
            </div>
            <!--suffix="<span pill class='badge' style='background:red;color:#fff;margin-top:-40px;margin-right:-10px;'>4</span>"-->
            <!-- <div style="margin-bottom:-18px;margin-top:10px;">
              <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged">
                  <tab id="public" name="Public Chat">

                  </tab>
                  <tab id="private" name="Private Chats" >

                  </tab>
                  <tab id="contacts" name="Contacts">

                  </tab>
              </tabs>
          </div> -->
            <!-- <div class="col-md-5" style="text-align : right;margin-bottom:-20px;margin-top:-20x;" v-if="showEnquiry">
            <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && enquirySelected" v-on:click="viewPrivateInquiries">{{texts.privatechat}}  <badge type="white"></badge></base-button>
            <base-button type="primary" class="btn-sm" v-if="private_inquiries.length > 0 && !enquirySelected" v-on:click="viewPrivateInquiries">{{texts.publicchat}}  <badge type="white"></badge></base-button>
            </div> -->
            </div>
             <!-- <span style="font-size: 18px; color: black;width:85%;" id="exampleModalLabel">{{texts.inquiry}}</span> -->
          </template>
            <card header-classes="bg-white" style="display:table;/*height:700px;*/background-color: white;background: #fff;position: -webkit-sticky;
position: sticky;  top: 0;width:100%;">

          <!-- <div> -->

          <div style="height:90%;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="!showEnquiry && !isContacts">
            <card v-for="chat in private_inquiries" header-classes="bg-white" style="background-color: white;background: #fff;margin-bottom:15px;" >
              <div class="row" style="margin-top:-20px;">

                <!-- <div  class="col-md-1" style="margin-top:-12px;">
                <badge  type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">!</badge>
                </div> -->

                <div class="col-md-8" style="margin-top:3px;">
                  <h3  >{{chat.title}}</h3>
                </div>

                <div class="col-md-4" style="margin-top:-10px;">
                  <button type="button" style="float: right;margin-top: 10px;" class="btn btn-success btn-sm" v-on:click="inquiryClicked(chat)">{{texts.view}}   <badge type="white"></badge></button>
                </div>

                  <!-- </div> -->
                <!-- <br> -->
                <!-- <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
                <br>
                <br>
                <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

                <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span> -->
              </div>
              <div class="row">
                <div class="col-md-12">
                  <span style="font-size:14px;">
                    {{chat.last_message.message}}
                  </span>
                </div>
              </div>

              <div class="row" style="margin-bottom:-15px;">
                <div class="col-md-12">
                  <span style="font-size:12px;">
                    {{chat.last_message.datetime}}
                  </span>
                </div>
              </div>
            </card>
            <!-- <div v-for="(r, pos) in inquiries">
           <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " ><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
           <br>
           </div> -->
          </div>

          <div style="/*overflow-y: scroll; height:200px;*/height:200px;overflow:auto; display:flex; flex-direction:column-reverse;" v-if="inquiries.length > 0 && showEnquiry">

            <div v-for="(r, pos) in inquiries">
           <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; " v-if="language=='ltr'"><span style="color:#000;font-weight: bold;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:right;">{{r.datetime}}</div></div>
           <div style="white-space: pre-line;background-color:#dadada; border-radius:20px;padding:10px;color:#000;word-wrap: break-word; text-align:right;" v-else><span style="color:#000;font-weight: bold;text-align:right;">{{r.sender_name}}<br></span>{{r.message}}<div style="font-size:12px;text-align:left;">{{r.datetime}}</div></div>
           <br>
           </div>
          </div>
          <div v-if="showEnquiry">
            <br>
          <textarea v-if="language == 'ltr'" class="form-control"  placeholder="Write a message.."
                           type="text"
                           v-model="chat_message" rows="3"
                           >
               </textarea>
               <textarea v-else dir="rtl" class="form-control"  placeholder="اكتب رسالة .."
                                type="text"
                                v-model="chat_message" rows="3"
                                >
                    </textarea>

          </div>

          <div class="row" v-if="false" style="margin-bottom:-20px;">
            <div class="col-md-8">
              <base-checkbox v-model="is_public" >{{texts.public}}</base-checkbox>
            </div>
            <div class="col-md-4" style="margin-bottom:-25px;">
              <base-checkbox v-model="is_private">{{texts.private}}</base-checkbox>
            </div>
            <!-- <div class="col-md-8">
              <div class="avatar-group">
                <span href="#" class="avatar avatar-sm rounded-circle myDIV" data-toggle="tooltip" data-original-title="Ryan Tompson"
 v-b-tooltip.hover.left title="Tooltip on left">
                  <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">

                </span>
                <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Romina Hadid">
                  <img alt="Image placeholder" src="img/theme/team-2-800x800.jpg">
                </span>
                <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Alexander Smith">
                  <img alt="Image placeholder" src="img/theme/team-3-800x800.jpg">
                </span>
                <span href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Jessica Doe">
                  <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg">
                </span>
              </div>
            </div> -->

          </div>

          <template slot="footer" v-if="showEnquiry">
            <!-- <div class="row"> -->
              <!-- <div class="col-md-4">
              <base-button type="secondary" @click="modals.modalinquirybox = false;">{{texts.close}}</base-button>
              </div> -->
              <!-- <br> -->
              <!-- <div class="col-md-1"> -->
              <base-button type="primary" @click="sendChat()" style="width:100%;height:60px;">{{texts.send}}</base-button>
              <!-- </div> -->
              <!-- </div> -->
              <!-- <base-button v-if="isManager" @click="approveMinutes()" type="primary">{{texts.approveminutes}}</base-button> -->

          </template>

          <div style="overflow-y: scroll; height:250px;" v-if="isContacts">
            <!-- <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;" v-if="language=='ltr'">{{texts.back}}</base-button>
            <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;align-items:right;" v-else>{{texts.back}}</base-button> -->
            <h2 v-if="language == 'ltr'">Client Representatives</h2>
            <h2 v-else style="text-align:right;">العملاء</h2>
            <h5 style="color:#808080" v-if="language == 'ltr'">Please tick the Client Representatives you want to include in the message and keep the ones you do not want to include unticked.</h5>
            <h5 style="color:#808080;text-align:right;" v-else>يرجى وضع علامة على العملاء الذين تريد تضمينهم في الرسالة فقط</h5>
            <br>
            <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos1) in committeemembers" :key="pos1" v-model="committeemembers[pos1].checked">
                   {{fieldName.name}} - {{fieldName.title}}
               </base-checkbox>

             <base-checkbox v-else style="text-align:right;" class="mb-3" v-for="(fieldName, pos2) in committeemembers" :key="pos2" v-model="committeemembers[pos2].checked">
                    {{fieldName.name}} - {{fieldName.title}}
                </base-checkbox>

        </div>
        <template slot="footer" style="justify-content:centered;" v-if="isContacts">
            <base-button type="primary" @click="sendPrivateChatMessage()" style="width:100%;height:60px;">{{texts.send}}</base-button>
        </template>

          <!-- </div> -->
          </card>
          <!-- </div> -->
        </modal>


        <modal id="CMembersModal" :show.sync="modals.cmembersmodal" dir="ltr">
        <template slot="header">
           <!-- <span style="font-size: 24px; color: black;" id="exampleModalLabel" v-if="language == 'ltr'">{{texts.chats}}</span>
           <span style="font-size: 24px; color: black;text-align : right;" id="exampleModalLabel" v-else >{{texts.chats}}</span> -->
        </template>
          <div style="overflow-y: scroll; height:400px;">
            <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;" v-if="language=='ltr'">{{texts.back}}</base-button>
            <base-button class="btn-primary btn-sm" v-on:click="modals.cmembersmodal = false;" style="margin-bottom:10px;align-items:right;" v-else>{{texts.back}}</base-button>
            <h2 v-if="language == 'ltr'">Client Representatives</h2>
            <h2 v-else style="text-align:right;">العملاء</h2>
            <h5 style="color:#808080" v-if="language == 'ltr'">Please tick the Client Representatives you want to include in the message and keep the ones you do not want to include unticked.</h5>
            <h5 style="color:#808080;text-align:right;" v-else>يرجى وضع علامة على العملاء الذين تريد تضمينهم في الرسالة فقط</h5>
            <br>
            <!-- <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos5) in committeemembers" :key="pos5" v-model="committeemembers[pos5].checked">
                   {{fieldName.name}} - {{fieldName.title}}
               </base-checkbox>

             <base-checkbox v-else style="text-align:right;" class="mb-3" v-for="(fieldName, pos3) in committeemembers" :key="pos3" v-model="committeemembers[pos3].checked">
                    {{fieldName.name}} - {{fieldName.title}}
                </base-checkbox> -->

        </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="primary" @click="sendPrivateChatMessage()" style="width:100%;height:60px;">{{texts.send}}</base-button>
        </template>
       </modal>


        <modal id="chatsModal" :show.sync="modals.modal0" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel" v-if="language == 'ltr'">{{texts.chats}}</span>
           <span style="font-size: 24px; color: black;text-align : right;" id="exampleModalLabel" v-else >{{texts.chats}}</span>
        </template>
          <div style="overflow-y: scroll; height:400px;">
          <card v-for="chat in chats" header-classes="bg-white" style="background-color: white;background: #fff;" >
            <div class="row">
              <div v-if="true" class="col-1" style="margin-top:-12px;">
              <badge v-if="chat.notifications > 0" type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">{{chat.notifications}}</badge>
              </div>

              <h2 class="col-7" style="margin-top:-10px;">{{chat.title}}</h2><div class="col-4"  style="width: 100%; margin-top:-15px;">

              <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="onClick(chat)">{{texts.view}}</button>

                </div>

              <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
              <br>
              <br>
              <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

              <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span>
            </div>
          </card>



        </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="primary"  icon="ni ni-fat-add" style="font-size:13px;border-radius:50px;" @click="newPublicChat()">{{texts.publicchat}}</base-button>
            <base-button type="info" icon="ni ni-fat-add" style="font-size:13px;border-radius:50px;"  @click="newPrivateChat()">{{texts.privatechat}}</base-button>
            <base-button type="secondary" @click="modals.modal0 = false" style="margin-left:50px;">{{texts.close}}</base-button>
        </template>
       </modal>

       <modal :show.sync="modals.modal12" modal-classes="modal-dialog-centered modal-lg" :dir="language">
       <template slot="header">
          <span v-if="language=='ltr'" style="font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{texts.logs}}</span>
          <span v-else style="text-align:right;font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{texts.logs}}</span>
       </template>
       <!-- <h4>Minutes</h4> -->
       <div v-if="language =='ltr'" style="overflow-y: scroll; height:300px;">
         <PostponeLogsTable title="Progress" :tableData="postponing_logs"></PostponeLogsTable>
        <!-- <p style="white-space: pre-line;" v-for="(r, pos) in postponing_logs">[{{r.datetime}}] : {{r.notes}}</p> -->
       </div>
       <div v-else style="text-align:right;overflow-y: scroll; height:300px;">
         <PostponeLogsTable title="Progress" :tableData="postponing_logs"></PostponeLogsTable>
        <!-- <p style="white-space: pre-line;" v-for="(r, pos) in postponing_logs">[{{r.datetime}}] : {{r.notes}}</p> -->
       </div>
       <!-- <template slot="footer"> -->
       <div v-if="language =='ltr'">
         <base-button  type="secondary" @click="modals.modal12 = false">{{texts.close}}</base-button>
       </div>
       <div v-else style="text-align:right;" >
         <base-button   type="secondary" @click="modals.modal12 = false">{{texts.close}}</base-button>
       </div>

       <!-- </template> -->
       <!-- <template slot="footer" v-else style="text-align:right;" >
           <base-button style="text-align:right;"  type="secondary" @click="modals.modal12 = false">{{texts.close}}</base-button>
       </template> -->

      </modal>

    </div>
</template>
<script src="https://cdn.pubnub.com/sdk/javascript/pubnub.4.27.0.js"></script>

<script>
  import ProjectsTable from './Tables/ProjectsTable';
  import PostponeLogsTable from './Tables/PostponeLogsTable';
  import { mapState } from "vuex";
  // import { SEND_SMS } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { mapGetters } from "vuex";
  import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
  import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
  import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
  import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
  import UserService from "@/common/user.service";
  import JwtService from "@/common/jwt.service";
  import {Tabs, Tab} from 'vue-tabs-component';
  import { GET_OVERVIEW, CREATE_CHAT, GET_CHATS, SEND_MESSAGE, GET_COMMITTEE_MEMBERS,GET_TEAM_MEMBERS, SEND_CHAT_MESSAGE, GET_PUBLIC_CHAT, GET_PRIVATE_CHATS, GET_CHAT_BY_ID, GET_ONBOARDING } from "@/store/actions.type";
  import { Slider, SliderItem } from 'vue-easy-slider'
  Vue.use(VueClipboard)
  Vue.use(Tabs);
  Vue.use(Tab);
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker, ProjectsTable, PostponeLogsTable, Slider,
    SliderItem,Tabs, Tab},

    data() {
      return {
        isNewPrivate : false,
        chatIsOpen: false,
        isContacts :false,
        currentIndex : 0,
        currentOnboardingText :"",
        list: [
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture1.png"},
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture2.png"},
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture3.png"},
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture4.png"},
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture5.png"},
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture6.png"},
       { backgroundColor: '#eee', width: '100%', height: '100%', image : "../../screenshots/Picture7.png"}
     ],
        postponeData : [{title : "TEST", description : "ASLKDJASDLKAJSDLAKJSDasldkfjasldkfj asdlkfjas dlfkjas ldfkj alkjfdLASKJD ASLKDJASDLKAJSDLAKJSDasldkfjasldkfj asdlkfjas dlfkjas ldfkj alkjfdLASKJD", startdate : "2020-04-19", endate : "2020-04-19"},{title : "TEST", description : "ASLKDJASDLKAJSDLAKJSDLASKJD", startdate : "2020-04-19", endate : "2020-04-19"},{title : "TEST", description : "ASLKDJASDLKAJSDLAKJSDLASKJD", startdate : "2020-04-19", endate : "2020-04-19"},{title : "TEST", description : "ASLKDJASDLKAJSDLAKJSDLASKJD", startdate : "2020-04-19", endate : "2020-04-19"}],
        userType : JwtService.getUserType(),
        isManager : JwtService.getIsManager() === 1 ? true : false,
        texts : {
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
          next : UserService.getLanguage() === "rtl" ? "التالى" : "Next",
          chats : UserService.getLanguage() === "rtl" ? "الرسائل" : "Messages",
          view : UserService.getLanguage() === "rtl" ? "عرض" : "View",
          publicchat : UserService.getLanguage() === "rtl" ? "محادثة عامة" : "Public Chat",
          privatechat : UserService.getLanguage() === "rtl" ? "محادثة خاصة" : "Private Chats",
          contacts : UserService.getLanguage() === "rtl" ? "جهات الاتصال" : "Contacts",
          close : UserService.getLanguage() === "rtl" ? "إغلاق" : "Close",
          logs : UserService.getLanguage() === "rtl" ? "السجلات" : "Logs",
          send : UserService.getLanguage() === "rtl" ? "إرسال" : "Send",
          private : UserService.getLanguage() === "rtl" ? "خاص" : "Private",
          public : UserService.getLanguage() === "rtl" ? "عام" : "Public",
          onboarding : UserService.getLanguage() === "rtl" ? "جولة تعريفية" : "Tutorial",
        },
        language : UserService.getLanguage() || "ltr",
        postponing_logs : [],
        phone_no : '',
        title : '',
        budget : '',
        timeslot : '8:00-10:00',
        message : '',
        budget : '',
        tiers : {
          all : true,
          starter : false,
          silver : false,
          gold : false,
          platinum : false
        },
        isChatHidden : true,
        modals: {
          modal0 : false,
          modal12 : false,
          chatmodal : false,
          cmembersmodal : false,
          modalonboarding : false
        },
        showEnquiry : true,
        private_inquiries : [],
        enquirySelected : true,
        chat_message : "",
        chat_id : "",

        inquiries : [{sender_name : 'Test 1234', message : 'asdfkasjdfhsakdf', datetime : '10-10-20'},{},{}],
        is_public : true,
        is_private : false,
        teammembers : [],
        committeemembers : [{name : "Abdallah Masri", title : "CIO"}, {name : "Ahmad Tabbaa", title : "CRO"},{name : "Abdallah Masri", title : "CIO"}, {name : "Ahmad Tabbaa", title : "CRO"}],
        chats : [],
        isNewChat : false,
        chatId : "",
        chatType : "",
        chatTitle : "",
        tableData :[


        ],
        dates: {
          simple: new Date().toISOString().split(" ")[0]
        },
      icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [
        // {
        //   id: 'user1',
        //   name: 'Othman Barakat',
        //   imageUrl: ''
        // },
        // {
        //   id: 'user2',
        //   name: 'Nasser Barakat - Managing Partner',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: '',
      messageList: [
          // { type: 'text', author: `me`, data: { text: `Regarding the risk assessment report for phase 1, why is there a lack of documentation about the reported case on page 4 ?`,  meta: '06-16-2019 12:43' } },
          // { type: 'text', author: `user2`, data: { text: `Dear Mr. Ahmad, we have looked into your enquiry and found that indeed there was a lack of documentation. We shall update the report.` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      suggestions: ['some quick reply', 'another one'],
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4f2f81'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true
      }
    },
     computed: {
        ...mapGetters(["isAuthenticated", "overview", "assignmentId"])
      },
      watch: {
        is_public : function(oldVal, newVal) {
          if (oldVal && this.is_private) {
            this.is_private = false;
          }
          if (newVal) {
            this.is_private = true;
          }
        },
        is_private : function(oldVal, newVal) {
          if (oldVal && this.is_public) {

            this.is_public = false;
          }
          if (newVal) {
            this.is_public = true;
          }
        }
      },
  //     created() {
  //   window.addEventListener('beforeunload', this.beforeWindowUnload)
  // },
  //
  // beforeDestroy() {
  //   window.removeEventListener('beforeunload', this.beforeWindowUnload)
  // },

    mounted() {
      this.language = UserService.getLanguage() || "ltr";

      console.log(sessionStorage);
      // if (sessionStorage.getItem('reloaded') != null) {
      //   console.log('page was reloaded');
      // } else {
      //   this.$router.push({ name: "login" })
      //     console.log('page was not reloaded');
      // }

  // sessionStorage.setItem('reloaded', 'yes');
      // changeRTL () {
//       document.getElementById("mainDIV").addEventListener("click", function () {
//     this.modals.chatmodal = false;
//     alert("w");
// }, false);
//       document.addEventListener('click', function(event) {
//         this.modals.chatmodal = false;
//       });//, true);
      console.log("COMMITTEE");
      console.log(this.userType);
      if (String(this.userType) === "committee") {
        Promise.all([
          store.dispatch(GET_ONBOARDING, UserService.getAssignmentId())
        ]).then((data) => {
          if (Number(data[0]['onboarding']) === 0) {
              this.modals.modalonboarding = true;
          }
            this.loaded = true;
        });

        // UserService.saveOnOboarding("0");
      }

        this.$vuetify.rtl = true;
      // },
      console.log(store.getters.assignmentId);
      Promise.all([
        store.dispatch(GET_OVERVIEW, UserService.getAssignmentId())
      ]).then(() => {
          this.loaded = true;
      });
      // document.getElementById("chatsModal").childNodes[0].style = 'margin-right : 75px;background-color: #ffffff;';
      // document.getElementById("chat").style.visibility = "hidden";
      // document.getElementById("chat").childNodes[0].style="margin-right:125px;background-color: rgb(79, 47, 129);";
      // document.getElementById("chat").childNodes[0].childNodes[0].style="margin-right:125px;";
      // document.getElementById("chat").childNodes[0].childNodes[1].style="margin-right:125px;";

      Promise.all([
        store.dispatch(GET_COMMITTEE_MEMBERS,UserService.getAssignmentId())
      ]).then((data) => {
        console.log(data[0]['data']);
          this.loaded = true;

          console.log(store.getters.committeeMembers);
          this.committeemembers = data[0]['data'];
          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });

      Promise.all([
        store.dispatch(GET_TEAM_MEMBERS,UserService.getAssignmentId())
      ]).then((data) => {
        console.log(data[0]['data']);
          this.loaded = true;

          // console.log(store.getters.committeeMembers);
          let tMembers = data[0]['data'];
          for (let e = 0; e < tMembers.length; e++) {
              if (Number(tMembers[e].manager) === 1) {
                console.log(tMembers[e]);
                console.log("FOUND MANAGER");
                  this.teammembers.push(tMembers[e]);
                  console.log("TEAMMEMBERS");
                  console.log(this.teammembers);
              }
              else {
                console.log(tMembers[e]);
              }
          }
          console.log("TEAMMEMBERS");
          console.log(this.teammembers);

          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });

      Promise.all([
        store.dispatch(GET_PUBLIC_CHAT, UserService.getAssignmentId())
      ]).then((data) => {
        if (data[0]['errFlag'] == 0) {
          this.inquiries = data[0]['chat_messages'];
        }
      });

      Promise.all([
        store.dispatch(GET_PRIVATE_CHATS, UserService.getAssignmentId())
      ]).then((data) => {
        if (data[0]['errFlag'] == 0) {
          this.private_inquiries = data[0]['data'];
        }
      });
    },
    methods: {
      confirmLeave() {
        // return alert(1234);
    // return window.confirm('Do you really want to leave? you have unsaved changes!')
      },

      confirmStayInDirtyForm() {
        return true && !this.confirmLeave()
      },

      beforeWindowUnload(e) {
        // this.$router.push({ name: "login" })
        e.preventDefault();
        e.returnValue = '';
        // if (this.confirmStayInDirtyForm()) {
        //   // Cancel the event
        //   e.preventDefault()
        //   // Chrome requires returnValue to be set
        //   e.returnValue = ''
        // }
      },
      preventNav(event) {
        // if (!this.isEditing) return
        if (this.confirmStayInDirtyForm()) {
          event.preventDefault()
          event.returnValue = ""
        }
      },
      handler(event) {
        alert(event);
        event.preventDefault();
         console.log("CLOSING");
         console.log(event);
      },
      tabClicked(selectedTab) {
        if (String(selectedTab.tab.id) === "public") {
          this.enquirySelected = true;
          this.isContacts = false;
          Promise.all([
            store.dispatch(GET_PUBLIC_CHAT,UserService.getAssignmentId())
          ]).then((data) => {
            console.log(data);
            if (data[0]['errFlag'] == 0) {
              this.inquiries = data[0]['chat_messages'];
              this.showEnquiry = true;
              this.isPrivateInquiry = false;
              this.is_private = false;

              this.chat_id = "";
            }
          });
        }
        else if (String(selectedTab.tab.id) === "private") {
          this.enquirySelected = false;
          this.showEnquiry = false;
          this.isContacts = false;
        }
        else {
          this.showEnquiry = false;
          this.isContacts = true;
        }
        console.log(selectedTab);
      },
      tabChanged(selectedTab) {
        if (this.isNewPrivate) {
          this.isNewPrivate = false

        }
        if (String(selectedTab.tab.id) === "public") {
          this.isContacts = false;
          this.enquirySelected = true;

          Promise.all([
            store.dispatch(GET_PUBLIC_CHAT,UserService.getAssignmentId())
          ]).then((data) => {
            console.log(data);
            if (data[0]['errFlag'] == 0) {
              this.inquiries = data[0]['chat_messages'];
              this.showEnquiry = true;
              this.isPrivateInquiry = false;
              this.is_private = false;

              this.chat_id = "";
            }
          });
        }
        else if (String(selectedTab.tab.id) === "private") {
          this.enquirySelected = false;
          this.showEnquiry = false;
          this.isContacts = false;
        }
        else {
          this.showEnquiry = false;
          this.isContacts = true;
        }
        console.log(selectedTab.tab.id);
      },
      closeOnboarding() {
        this.modals.modalonboarding = false;
      },
      backOnBoarding() {
        if (this.currentIndex -1 < 0) {
          this.currentIndex = 0;
        }
        else {
            this.currentIndex = (this.currentIndex -1) % this.list.length;
        }
      },
      nextOnBoarding() {
        this.currentIndex = (this.currentIndex +1) % this.list.length;
      },
      sliderChanged(event) {
          console.log(event);
          this.currentIndex = event;
          // this.currentOnboardingText = this.list[event].text;
      },
      initiatePrivateChat() {
        this.inquiries = [];
        this.isContacts = false;
        this.showEnquiry = true;
        this.is_private = true;
        this.isPrivateInquiry = true;
        this.is_public = false;
        this.isNewPrivate = true;
      },
      inquiryClicked(inquiry) {
        console.log("INQUIRY CLICKED");
        console.log(inquiry);
        this.chat_id = inquiry._id;
        Promise.all([
          store.dispatch(GET_CHAT_BY_ID, inquiry._id)
        ]).then((data) => {
          console.log(data);
          if (data[0]['errFlag'] == 0) {
            this.inquiries = data[0]['chat_messages'];
            this.chat_id = inquiry._id;
            this.showEnquiry = true;
            this.is_private = true;
            this.isPrivateInquiry = true;
            this.is_public = false;
            // this.viewPrivateInquiries();
            // this.modals.modal9 = false;
            // this.modals.modalinquirybox = true;
          }
        });
      },
      viewPrivateInquiries() {
        if (this.enquirySelected) {
          this.enquirySelected = false;
          this.showEnquiry = false;

        }
        else {
          this.enquirySelected = true;

          Promise.all([
            store.dispatch(GET_PUBLIC_CHAT,UserService.getAssignmentId())
          ]).then((data) => {
            console.log(data);
            if (data[0]['errFlag'] == 0) {
              this.inquiries = data[0]['chat_messages'];
              this.showEnquiry = true;
              this.isPrivateInquiry = false;
              this.is_private = false;

              this.chat_id = "";
            }
          });

        }
      },
      sendPrivateChatMessage() {
        let isCMembersChecked = false;
        for (let y = 0; y < this.committeemembers.length; y++) {
          if (this.committeemembers[y].checked) {
            isCMembersChecked = true;
          }
        }
        let isTMembersChecked = false;
        for (let y = 0; y < this.teammembers.length; y++) {
          if (this.teammembers[y].checked) {
            isTMembersChecked = true;
          }
        }

        if (!isTMembersChecked && this.isManager) {
          isTMembersChecked = true;
        }
        if (this.chat_message !== "" && isCMembersChecked && isTMembersChecked) {
          let type = "private";
          let formData = {"assignment_id" : UserService.getAssignmentId(), "chat_message" : this.chat_message, "type" : type, "chat_id" : this.chat_id, "committeemembers" : this.committeemembers, "teammembers" : this.teammembers};
          console.log(this.committeemembers);
          Promise.all([
            store.dispatch(SEND_CHAT_MESSAGE, formData)
          ]).then((data) => {
            if (data[0]['errFlag'] == 0) {
              this.chat_message = "";
              this.chat_id = data[0]['chat_id'];
              this.modals.cmembersmodal = false;
              this.showEnquiry = true;
              this.enquirySelected = false;
              this.is_private = false;
              this.is_public = false;
              this.isPrivateInquiry = true;
              for (let r = 0; r < this.committeemembers.length; r++) {
                this.committeemembers[r].checked = false;
              }
              for (let r = 0; r < this.teammembers.length; r++) {
                this.teammembers[r].checked = false;
              }
            }
            Promise.all([
              store.dispatch(GET_CHAT_BY_ID, this.chat_id)
            ]).then((data) => {
              if (data[0]['errFlag'] == 0) {
                this.inquiries = data[0]['chat_messages'];
              }
            });
            Promise.all([
              store.dispatch(GET_PRIVATE_CHATS, UserService.getAssignmentId())
            ]).then((data) => {
              if (data[0]['errFlag'] == 0) {
                this.private_inquiries = data[0]['data'];
              }
            });
          });
        }
        else {
          if (String(this.language) === "ltr") {
            this.$notify({
                  type: 'warning',
                  title: 'Please fill in all required fields'
                })
          }
          else {
            this.$notify({
                  type: 'warning',
                  title: 'يرجى تعبئة جميع الحقول المطلوبة'
                })
          }
        }
      },
      back() {
        window.history.back();
      },
      sendChat() {
        if (this.isNewPrivate) {
          this.sendPrivateChatMessage();
        }
        else {
          if (this.chat_message !== "") {
          let type = this.is_public ? "public" : "private";
          console.log("TYPE" + " " + type);
          let formData = {"assignment_id" : UserService.getAssignmentId(), "chat_message" : this.chat_message, "type" : type, "chat_id" : this.chat_id};
          if (type === "private" && this.chat_id === "") {
              this.modals.cmembersmodal = true;
          }
          else {
            console.log(type);
            console.log("SENDING MESSAGE");
            Promise.all([
              store.dispatch(SEND_CHAT_MESSAGE, formData)
            ]).then((data) => {
              if (type === "private") {
                this.chat_message = "";
                Promise.all([
                  store.dispatch(GET_CHAT_BY_ID, this.chat_id)
                ]).then((data) => {
                  console.log("GOT CHAT BY ID");
                  if (data[0]['errFlag'] == 0) {
                    this.inquiries = data[0]['chat_messages'];
                  }
                });
                Promise.all([
                  store.dispatch(GET_PRIVATE_CHATS, UserService.getAssignmentId())
                ]).then((data) => {
                  console.log("GOT PRIVATE CHATS");
                  if (data[0]['errFlag'] == 0) {
                    this.private_inquiries = data[0]['data'];
                  }
                });
              }
              else {
                Promise.all([
                  store.dispatch(GET_PUBLIC_CHAT, UserService.getAssignmentId())
                ]).then((data) => {
                  if (data[0]['errFlag'] == 0) {
                    this.chat_message = "";
                    this.inquiries = data[0]['chat_messages'];
                  }
                });
              }

            });
          }
        }
        else {
          if (String(this.language) === "ltr") {
            this.$notify({
                  type: 'warning',
                  title: 'Please fill in all required fields'
                })
          }
          else {
            this.$notify({
                  type: 'warning',
                  title: 'يرجى تعبئة جميع الحقول المطلوبة'
                })
          }
        }
        }

      },
      viewPostponingLogs(logs) {
        this.postponing_logs = logs;
        this.modals.modal12 = true;

      },
      newPublicChat() {
        this.modals.modal0 = false;
        if (Number(this.chats.length) === 0) {
          this.isNewChat = true;
          this.chatType = "public";
          document.getElementById("chat").style.visibility = "visible";
          this.openChat();
          this.chatTitle = "Public Inquiry";
          // if (this.userType === "team") {
          //   this.participants = ["Committee Members"]
          // }
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
        }
        else {
          this.isNewChat = false;
          this.chatType = "public";
          document.getElementById("chat").style.visibility = "visible";
          let isChatFound = false;
          for (let i = 0 ; i < this.chats.length; i++) {
            console.log(this.chats[i]);
              if (this.chats[i].type === "public") {
                this.messageList = this.chats[i].messages;
                this.chatId = this.chats[i].id;
                this.participants = this.chats[i].participants;
                isChatFound = true;
                break;
              }
          }
          if (!isChatFound) {
            this.messageList = [];
            this.chatId = "";
            this.participants = [];
          }
          this.openChat();
          this.chatTitle = "Public Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
        }
      },
      newPrivateChat() {
        this.modals.modal0 = false;
        if (Number(this.chats.length) === 0) {
          this.isNewChat = true;
          this.chatType = "private";
          document.getElementById("chat").style.visibility = "visible";
          this.openChat();
          this.chatTitle = "Private Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
        }
        else {
          this.isNewChat = false;
          this.chatType = "private";
          document.getElementById("chat").style.visibility = "visible";
          let isChatFound = false;
          for (let i = 0 ; i < this.chats.length; i++) {
              if (this.chats[i].type === "private") {
                this.messageList = this.chats[i].messages;
                this.chatId = this.chats[i].id;
                this.participants = this.chats[i].participants;
                isChatFound = true;
                break;
              }
          }
          if (!isChatFound) {
            this.messageList = [];
            this.chatId = "";
            this.participants = [];
          }

          this.openChat();
          this.chatTitle = "Private Inquiry";
          document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
        }
      },
      onClick(chat) {
        // this.isChatHidden = true;

        // document.getElementById("chatsModal").childNodes[0].childNodes[0].style = 'background-color: #ffffff;opacity: 0.0;';
        this.modals.modal0 = false;
        this.messageList = chat.messages;
        this.chatId = chat.id;
        this.participants = chat.participants;
        // this.chatType = chat.type;
        console.log(chat);
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = chat.title;
        document.getElementById("chat").style.visibility = "visible";


        this.openChat();
      },
      openChatModal() {
        console.log(this.teammembers);
        // if (this.isChatOpen) {
        //   this.isChatOpen = false;
        // }
        // else {
        //   this.isChatOpen = true;
        // }
        if (this.modals.chatmodal) {
          this.modals.chatmodal = false;
        }
        else {
          this.modals.chatmodal = true;
          // Promise.all([
          //   store.dispatch(GET_CHATS)
          // ]).then((data) => {
          //   console.log(data[0]['data']);
          //     if (data[0]['data']) {
          //         this.chats = data[0]['data'];
          //     }
          //     else {
          //       this.chats = [];
          //     }
          //
          //     this.modals.modal0 = true;
          //
          // });

        }
      },
      sendMessage (text) {
        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
      if (text.length > 0) {
        if (this.isNewChat) {
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(CREATE_CHAT);
          Promise.all([
            store.dispatch(CREATE_CHAT, formData)
          ]).then(() => {
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
        }
        else {
          // Promise.all([
          //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
          // ]).then(() => {
          //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          // });
        }

      }
    },
    onMessageWasSent (message) {
      let canSend = (this.userType === "team" && JwtService.getIsManager() === 1) || (this.userType === "committee");
      if (canSend) {
        console.log(message);
        message.author = UserService.getUserId();
        // called when the user sends a message

        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
        if (message.data.text.length > 0) {
        if (this.isNewChat) {
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(CREATE_CHAT);
          Promise.all([
            store.dispatch(CREATE_CHAT, formData)
          ]).then((data) => {
            this.chatId = data[0]['chatId'];
            this.isNewChat = false;
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            message.author = "me";
            this.messageList = [ ...this.messageList, message ]
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
        }
        else {
          message.author = UserService.getUserId();
          let formData = {'assignment_id' : UserService.getAssignmentId(), 'chat_id' : this.chatId,  'text' : message.data.text, 'chat_type' : this.chatType};
          console.log(formData);
          console.log(SEND_MESSAGE);
          Promise.all([
            store.dispatch(SEND_MESSAGE, formData)
          ]).then(() => {
            this.isNewChat = false;
            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
            message.author = "me";
            this.messageList = [ ...this.messageList, message ]
            // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          });
          // Promise.all([
          //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
          // ]).then(() => {
          //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
          // });
        }

        }
      }
      else {
        this.$notify({
          'type' : 'warning',
          'title' : 'You are not allowed to send a message'
        });
      }

    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0

      // document.getElementById("chat").childNodes[1].style['margin-right'] = '100px';
      // if (document.getElementById("chat").childNodes[1].childNodes) {
      //   console.log("FOUND CHILD NODES");
      //   // console.log(document.getElementById("chat").childNodes[1].childNodes);
      //   for (let i =0 ; i < document.getElementById("chat").childNodes[1].childNodes.length; i++) {
      //     // console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
      //     if (i == 1) {
      //       console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
      //       for (let g = 0; g < document.getElementById("chat").childNodes[1].childNodes[i].childNodes.length; g++) {
      //         document.getElementById("chat").childNodes[1].childNodes[i].childNodes[g].style = 'margin-right : 100px';
      //       }
      //
      //     }
      //     if (document.getElementById("chat").childNodes[1].childNodes[i].style) {
      //         document.getElementById("chat").childNodes[1].childNodes[i].style['margin-right'] = '100px';
      //     }
      //     else {
      //       document.getElementById("chat").childNodes[1].childNodes[i].style = 'margin-right : 100px';
      //     }
      //
      //   }
      // }
      // else {
      //   console.log("NO CHILD NODES");
      // }
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m=>m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
      onPubnub(msg) {
                for (let i = 0; i < this.tableData.length; i++) {
                  this.tableData.push(msg.message);
                  // if (this.tableData[i].token === msg.message) {
                  //   this.tableData[i].hasLocation = true;
                  //   this.tableData[i].status = 2;
                  //   this.tableData[i].statusType = 'success';
                  // }
                }
      },

      onSubmit() {
        // console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            if (this.phone_no !== '' ) {
                this.localerrors = null;


                let formData = {'phone_no':this.phone_no};
                console.log(formData);
                Promise.all([
                  store.dispatch(SEND_SMS, formData),

                ]).then(() => {
                    this.isLoading = false;

                });
            }
            else {

              this.localerrors = "Phone cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>

<style>
  .tabs-component {
    //margin: 4em 0;
  }

  .tabs-component-tabs {
    border: solid 1px #ddd;
    border-radius: 6px;
    margin-bottom: 5px;
  }

  @media (min-width: 700px) {
    .tabs-component-tabs {
      border: 0;
      align-items: stretch;
      display: flex;
      justify-content: flex-start;
      margin-bottom: -1px;
    }
  }

  .tabs-component-tab {
    color: #999;
    font-size: 14px;
    font-weight: 600;
    margin-right: 0;
    list-style: none;
  }

  .tabs-component-tab:not(:last-child) {
    border-bottom: dotted 1px #ddd;
  }

  .tabs-component-tab:hover {
    color: #666;
  }

  .tabs-component-tab.is-active {
    color: #000;
  }

  .tabs-component-tab.is-disabled * {
    color: #cdcdcd;
    cursor: not-allowed !important;
  }

  @media (min-width: 700px) {
    .tabs-component-tab {
      background-color: #fff;
      border: solid 1px #ddd;
      border-radius: 3px 3px 0 0;
      margin-right: .5em;
      transform: translateY(2px);
      transition: transform .3s ease;
    }

    .tabs-component-tab.is-active {
      border-bottom: solid 1px #fff;
      z-index: 2;
      transform: translateY(0);
    }
  }

  .tabs-component-tab-a {
    align-items: center;
    color: inherit;
    display: flex;
    padding: .75em 1em;
    text-decoration: none;
  }

  .tabs-component-panels {
    //padding: 4em 0;
  }

  @media (min-width: 700px) {
    .tabs-component-panels {
      /*border-top-left-radius: 0;
      background-color: #fff;
      border: solid 1px #ddd;
      border-radius: 0 6px 6px 6px;
      box-shadow: 0 0 10px rgba(0, 0, 0, .05);
      padding: 4em 2em;*/
    }
  }</style>
